/* ---------------------------------------------------------------------------
   UF BENEFITS — the card flip.

   The whole card is tappable and the button inside it is the real control.
   That split matters: a card-wide click handler is invisible to a keyboard and
   silent to a screen reader, so the button carries the semantics and the
   card-wide handler is the convenience layer on top.

   The visibility toggle is not decoration either. backface-visibility hides a
   face from the eye but leaves its text focusable and readable by assistive
   tech — so without it, tabbing through the page walks into the contents of a
   card that appears to be showing something else entirely.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  /* ITS OWN FLAG. This file was forked from uf-benefits.js and inherited its
     guard name, so on any page carrying BOTH sections — the tabbed one and the
     card grid — whichever script loaded first claimed the flag and the other
     returned immediately and did nothing at all. STIM only has the cards, so it
     never showed up until creatine put the two on one page. */
  if (window.__ufBenefitsCardsBound) return;
  window.__ufBenefitsCardsBound = true;

  function setFlipped(card, flipped) {
    card.classList.toggle('is-flipped', flipped);

    var front = card.querySelector('.uf-benefits__face--front');
    var back = card.querySelector('.uf-benefits__face--back');
    if (front) front.toggleAttribute('data-uf-face-hidden', flipped);
    if (back) back.toggleAttribute('data-uf-face-hidden', !flipped);

    /* Announce the state on the control that was pressed rather than on the
       card, because the control is what a screen reader user is sitting on. */
    Array.prototype.slice
      .call(card.querySelectorAll('[data-uf-benefit-flip]'))
      .forEach(function (btn) {
        btn.setAttribute('aria-expanded', String(flipped));
      });
  }

  document.addEventListener('click', function (event) {
    var card =
      event.target.closest && event.target.closest('[data-uf-benefit-card]');
    if (!card) return;

    /* A link inside a card should follow the link, not turn the card over. */
    if (event.target.closest('a')) return;

    /* Same for the variant button. It has its own job and the card turning
       over underneath it would read as the tap having gone wrong. */
    if (event.target.closest('[data-uf-pick-variant]')) return;

    setFlipped(card, !card.classList.contains('is-flipped'));
  });

  /* Escape returns a flipped card to its front, which is what people expect
     from anything that opened. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var card =
      event.target.closest && event.target.closest('[data-uf-benefit-card]');
    if (!card || !card.classList.contains('is-flipped')) return;

    setFlipped(card, false);

    var btn = card.querySelector('.uf-benefits__face--front [data-uf-benefit-flip]');
    if (btn) btn.focus();
  });

  /* ---------------------------------------------------- pick a variant

     A card that describes a variant can select it. The buy box radios stay the
     source of truth — this finds the matching one, moves it, and lets the
     existing change handler do everything else: price, media, stock, the hidden
     cart id and the page accent all follow from that one event.

     Matching on the label text rather than a variant id, so the setting can be
     typed by a human and survives a variant being recreated.
  */
  function flavourInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-uf-flavour]')
    );
  }

  function findInput(wanted) {
    var needle = String(wanted || '').toLowerCase().trim();
    if (!needle) return null;
    var found = null;
    flavourInputs().forEach(function (input) {
      if (found) return;
      var label = input.closest('label');
      var text = (label ? label.textContent : '').toLowerCase();
      if (text.indexOf(needle) > -1) found = input;
    });
    return found;
  }

  /* Buttons show which variant is live, so the section reads as connected to
     the buy box rather than as three links that all look the same. */
  function syncPickState() {
    var checked = document.querySelector('[data-uf-flavour]:checked');
    var current = checked && checked.closest('label')
      ? checked.closest('label').textContent.toLowerCase()
      : '';

    Array.prototype.slice
      .call(document.querySelectorAll('[data-uf-pick-variant]'))
      .forEach(function (btn) {
        var needle = (btn.getAttribute('data-uf-pick-variant') || '').toLowerCase().trim();
        var on = needle !== '' && current.indexOf(needle) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-current', on);
      });
  }

  document.addEventListener('click', function (event) {
    var btn =
      event.target.closest && event.target.closest('[data-uf-pick-variant]');
    if (!btn) return;

    var input = findInput(btn.getAttribute('data-uf-pick-variant'));
    if (!input) return;

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Selecting a variant three screens below the price is invisible unless the
       customer is taken to where it changed. */
    var target =
      document.querySelector('.uf-pdp__buybox') ||
      document.querySelector('[data-uf-flavour-group]');
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-uf-flavour]')) {
      syncPickState();
    }
  });

  syncPickState();
})();
